//      
import React, {           } from 'react';

import { mergeClassNames } from 'utils/functions';

                 
                                          
                      
                         
                  
                                               
                   
 


export const Row = React.forwardRef((props          , ref) => {
    let {
        gutters = true,
        className = '',
        children,
        ...domProps
    } = props;

    className = mergeClassNames('row', !gutters ? 'no-gutters' : '', className);

    return <div ref={ref} className={className} {...domProps}>{children}</div>;
});

export default Row;
